import { render, staticRenderFns } from "./trains.vue?vue&type=template&id=23e186a0&scoped=true"
import script from "./trains.vue?vue&type=script&lang=js"
export * from "./trains.vue?vue&type=script&lang=js"
import style0 from "./trains.vue?vue&type=style&index=0&id=23e186a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e186a0",
  null
  
)

export default component.exports